import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LLCTransaction } from '@models/llc-mortgages';
import { MortgageStep } from '@models/mortgage';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Select } from '@ngxs/store';
import { MatterMortgageDispatch } from '@state/matter/matter_mortgages';
import { LLCMortgageState } from '@state/mortgages/llc-mortgage/llc-mortgage.state';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Step } from 'src/app/shared/atomic/molecules/step-progress-nav/step-progress-nav.component';

export interface LLCNewMatterModalData {
	transactionId: string;
}

const Steps: Step[] = [
	{
		title: 'Add borrower(s)',
		subTitle:
			"Import lender's borrower records into your matter or add from existing client database",
	},
	{
		title: 'Sync data',
		subTitle: 'Import other pertinent details from instructions',
	},
];

@UntilDestroy()
@Component({
	selector: 'app-new-matter',
	templateUrl: './new-matter.component.html',
	standalone: false,
})
export class LLCNewMatterModalComponent implements OnInit {
	public steps = Steps;
	public current = 0;
	public transaction: LLCTransaction;
	public matterMortgageId: string;

	@Select(LLCMortgageState.getLLCMortgage) llcMortgageFilterFn$: Observable<
		(id) => LLCTransaction
	>;

	constructor(
		public dialogRef: MatDialogRef<LLCNewMatterModalComponent>,
		@Inject(MAT_DIALOG_DATA) public data: LLCNewMatterModalData,
		private matterMortgageDispatch: MatterMortgageDispatch,
	) {}

	ngOnInit(): void {
		if (this.data?.transactionId) {
			this.getMortgage$(this.data.transactionId).subscribe((_transaction) => {
				this.transaction = _transaction;
				this.matterMortgageId = _transaction.matterMortgageId;
			});
		}
		this.dialogRef.updateSize('1000px');
	}

	getMortgage$(id: string): Observable<LLCTransaction> {
		return this.llcMortgageFilterFn$.pipe(
			untilDestroyed(this),
			map((fn) => fn(id)),
		);
	}

	goToMortgage() {
		this.matterMortgageDispatch.updateMortgage(this.matterMortgageId, {
			step: MortgageStep.CREATED,
		});
		this.dialogRef.close();
	}
}
